import React, { useEffect } from 'react';


import { makeStyles } from 'tss-react/mui';
import { Button, ContentTemplate, Divider, SectionHeader, TitleHeader } from 'web-library';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import RouteKey from '../../../routes/key';
import ExamInstruction from './ExamInstruction';
import { usePostGroupAmendmentCheckEligibility } from '../../../api-refactored/group-subject-amendment/usePostGroupAmendmentCheckEligibility';
import ExamNotAvailable from '../../../modules/examRegistration/components/ExamNotAvailable';
import { useWOGAA } from '../../../hooks/wogaa';

const useStyles = makeStyles()((theme) =>
({
  title: {
    marginBottom: theme.spacing(2),
  },
  submitForm: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
  },
  link: {
    color: theme.color.link.linkActive01,
  },
  iconButton: {
    padding: theme.spacing(1),
    margin: 0,
    marginLeft: theme.spacing(2),
  },
  formContainer: {
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(2),

    '& .MuiFormLabel-root': {
      marginBottom: theme.spacing(2),
    },
  },
  spacing: {
    marginBottom: theme.spacing(6),
  },
  actionButton: {
    marginRight: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
    marginRight: theme.spacing(2),
  },
  paragraph: {
    marginBottom: theme.spacing(1),
  },
}));

const { amendment } = RouteKey.child;
const { coordinatorSelectCandidate, coordinatorExamRegistrations } = RouteKey.amendment.child;

const CoordinatorStartAmendment = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const history = useHistory();

  const { examTypeCode } = useParams<{ examTypeCode: string }>();

// wogaa tracking for coordinator exam registration amendment //
  const { transactionStart } = useWOGAA('myexamsseab-6455');

  const {
    data: checkEligibilityData,
    mutate: checkEligibilityMutate,
  } = usePostGroupAmendmentCheckEligibility({});

  useEffect(() => {
    if (examTypeCode) {
      checkEligibilityMutate({ examType: examTypeCode });
    }
  }, [examTypeCode, checkEligibilityMutate]);

  if (examTypeCode && checkEligibilityData && !checkEligibilityData.eligible) {
    return (
      <ExamNotAvailable
        examTitle={t('amendment->>GroupSubjectAmendment.NewSubjectAmendment')}
        examTypeDisplay=""
        eligibleErrorCode={checkEligibilityData?.error.code || ''}
      />
    );
  }

  return (
    <>
      <TitleHeader title={t('amendment->>GroupSubjectAmendment.NewSubjectAmendment')} />
      <ContentTemplate>
        <ExamInstruction examType={examTypeCode} />
        <Divider paddingTop />
        <SectionHeader title={t('amendment->>GroupSubjectAmendmentRegister.GetStarted')} />

        <Button
          id="button-groupExamRegistration-startSelectCandidate"
          className={classes.button}
          onClick={() => {
            transactionStart();
            history.push(
              `/${amendment}/${coordinatorExamRegistrations.route}/${coordinatorSelectCandidate.route}/${examTypeCode}`
            );
          }}
        >
          {examTypeCode === 'IPSLE'
            ? t('amendment->>SubjectAmendmentRegister.Start Subject Amendment')
            : t('amendment->>GroupSubjectAmendmentRegister.StartSelectCandidate')}
        </Button>
      </ContentTemplate>
    </>
  );
};

export default CoordinatorStartAmendment;
